import { createTeleporter } from 'react-teleporter';

export const PopupMenuTeleporter = createTeleporter();

export const ViewTitleBarTeleporter = createTeleporter({
  multiSources: true,
});

export const RightClickMenuTeleporter = createTeleporter({
  multiSources: true,
});
